<template>
    <CommonPopupFrame :changeHeight="90"  :closeCompleteAction="closeAction" :isOpen="isOpen" :changeBottom="0" :is-back-press-apply="true">
        <div style="height:20px;">
            <div style="width: 36px; height: 5px; background-color: rgb(217, 217, 217); margin: 5px auto 0px; border-radius: 5px;"></div>
        </div>
        <div style="display:flex; position:relative;">
            <div style="color:#210F03; font-size:16px; font-weight:bold; padding-left:24px;" @click="closeAction">닫기</div>
            <div style="flex:1;"></div>
        </div>
        <div style="padding:0px 12px;">
            <div style="font-weight: 700; line-height: 24px; margin-bottom: 15px;text-align:center; padding:10px 0px;">모든 멤버톡</div>
            <div style="display: flex; justify-content: space-between; margin-bottom:20px; align-items: flex-start;">
                <div style="display:flex;">
                    <!-- 필터 -->
                    <div style="display: flex; gap: 8px; margin-right:10px; ">
                        <div @click="showAgeFilters(); $Util.sendEventClick(`모든_멤버톡_필터_나이대`, true)" :style="{ border: cur_age_sort_key !== '모든 나이대' ? '2px solid #210f03' : '1px solid #d9d9d9' }" style="padding: 8px 12px; display: flex; gap: 4px; align-items: center; font-weight: 700; font-size: 14px; border-radius: 50px; border: 2px solid #210f03;">
                            <div style="line-height: 24px; ">{{cur_age_sort_key}}</div>
                            <img style="width: 6px; transform: rotate(90deg);" :src="require('@/assets/img/right_arrow.png')" alt="">
                        </div>
                    </div>

                    <div style="display: flex; gap: 8px;">
                        <div @click="showTagFilters(); $Util.sendEventClick(`멤버_멤버톡_필터_태그`, true)" :style="{ border: cur_tag_sort_key !== '멤버톡 태그' ? '2px solid #210f03' : '1px solid #d9d9d9' }" style="padding: 8px 12px; display: flex; gap: 4px; align-items: center; font-weight: 700; font-size: 14px; border-radius: 50px; border: 2px solid #210f03;">
                            <div style="line-height: 24px; ">{{cur_tag_sort_key}}</div>
                            <img style="width: 6px; transform: rotate(90deg);" :src="require('@/assets/img/right_arrow.png')" alt="">
                        </div>
                    </div>
                </div>
                <div @click="makeMemberTalk" style="display: flex; flex-direction: column; align-items: center; gap: 6px; margin-top: 3px;">
                    <div>
                        <img style="width: 30px;" :src="require('@/assets/img/make_member_talk.png')" alt="">
                    </div>
                    <div style="font-size: 12px; font-weight: 700;">멤버톡 만들기</div>
                </div>
            </div>
        </div>

        <InfinityScroll style="flex:1;overflow:auto;" :is-enable-next-page-handle="isEnableNextPageHandleRecruit" :handle-next-page="handleNextPage" >
            <div @touchmove.stop="() => {}" style="padding:0px 12px;">
                <div v-for="each, i in chatList" :key="i" style="margin-bottom: 16px;">
                    <MemberTalkList :joinMemberTalkConfirm="(item) => { showJoinChat(item, i, true) }" :index="i" :isInvitation="true" :memberList="each"></MemberTalkList>
                </div>
            </div>
        </InfinityScroll>
        <CommonPopupFrame :changeBottom="0" :changeHeight="232" :changeHeightUnit="'px'" :isOpen="isShowModal" :closeCompleteAction="closeModal">
            <div  style="padding: 16px 20px;">
                <div @click="closeModal" style="font-weight: 700;">닫기</div>
                <div style="margin-top: 32px; font-size: 20px; font-weight: 700; text-align: center;">멤버톡에 참여할까요?</div>
                <div @click="enterJoin" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 186px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">참여하기</div>
            </div>
        </CommonPopupFrame>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions" />
    </CommonPopupFrame>
</template>

<script>
    import CommonPopupFrame from "../my/CommonPopupFrame";
    import MemberTalkList from "../../common/MemberTalkList";
    import {JOIN_STATE} from "../../../Constants";
    import InfinityScroll from "../../common/InfinityScroll";
    import BottomPopupMenu from "../../common/BottomPopupMenu";
    import ResponseCode from "../../../ResponseCode";
    export default {
        name: "AllMemberTalkPopup",
        components: {BottomPopupMenu, InfinityScroll, MemberTalkList, CommonPopupFrame},
        data(){
            return {
                isOpen : false,
                cur_age_sort_key : '모든 나이대',
                cur_tag_sort_key : '멤버톡 태그',
                menuOptions : {},
                isShowPopMenu : false,
                chatList : [],
                isEnableNextPageHandleRecruit : true,
                pageRecruit : 1,
                isShowModal: false,
                detailInfo : {},
                curIndex : -1

            }
        },
        computed: {
            isExpert() {
                if (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach === '1') {
                    return true
                } else {
                    return false
                }
            },
        },
        methods : {
            makeMemberTalk() {
                this.$GlobalStore.addModal("MakeMemberTalkNew", { completeAction: this.completeAction })
            },
            completeAction() {
                this.chatList = []
                this.getMadeByMeChatList()
            },
            handleNextPage(){
                this.pageRecruit++;
                this.getMadeByMeChatList();
            },
            closeAction(){
                if(this.isOpen) {
                    this.isOpen = false;
                    return;
                }
                setTimeout(() => {
                    this.$GlobalStore.closeLastModal();
                }, 300)
            },
            async showJoinChat(detailInfo, i){
                this.curIndex = i;
                const chat_idx = detailInfo.chat_idx;

                if (!detailInfo.is_me_joined) {
                    this.detailInfo = detailInfo;
                    this.isShowModal = true;
                    return
                }

                await this.$Axios.showChattingBySoccerJoinIdx(chat_idx, this.getMessages, false, async (mode) => {
                    mode;

                    const parameters = {};
                    parameters.state = JOIN_STATE.OPEN;
                    parameters.is_with_members = true;
                    parameters.is_with_chat = true;
                    // if (this.isExpert) {
                    //     parameters.my_type = 'all'
                    // }

                    parameters.join_idx = detailInfo.idx;
                    const res = await this.$Axios.get('/api/join/list', { params: parameters });
                    if (res.data.joins) {
                        this.$set(this.chatList, i, res.data.joins);
                    } else {
                        this.$delete(this.chatList, i);
                    }
                });
            },
            showMyFriendsPopup(){
                this.$GlobalStore.addModal('MyFriendsPopup', {transitionName: 'bottom', isModalBackTransparent: true})
            },
            async enterJoin() {
                this.$GlobalStore.showProgress();
                const formData = new FormData;
                formData.append('join_idx', this.detailInfo.idx);
                const res = await this.$Axios.post('/api/join/member/apply', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

                this.$GlobalStore.hideProgress()
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.detailInfo.is_me_joined = true;
                    this.isShowModal = false;
                    this.$Util.sendEventClick("멤버톡_참여", true)
                    this.showJoinChat({ chat_idx: res.data.chat_idx, idx: this.detailInfo.idx, is_me_joined : true}, this.curIndex)
                } else if (res.data.code === ResponseCode.FAIL) {
                    alert(res.data.msg)
                }
            },
            closeModal() {
                this.isShowModal = false
                this.detailInfo = {}
            },
            showAgeFilters(){
                const labelAndAction = [];
                labelAndAction.push(
                    {
                        label: '모든 나이대', action: () => {
                            this.cur_age_sort_key = '모든 나이대';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '10대', action: () => {
                            this.cur_age_sort_key = '10대';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '20대', action: () => {
                            this.cur_age_sort_key = '20대';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '30대', action: () => {
                            this.cur_age_sort_key = '30대';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '40대', action: () => {
                            this.cur_age_sort_key = '40대';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '50대', action: () => {
                            this.cur_age_sort_key = '50대';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '60대 이상', action: () => {
                            this.cur_age_sort_key = '60대 이상';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false;
                        },
                    }
                );

                this.menuOptions = {
                    labelAndAction: labelAndAction,
                    isExistCancelBtn: true,
                    closeAction: () => {
                        this.isShowPopMenu = false
                    }
                };

                this.isShowPopMenu = true
            },
            showTagFilters(){
                const labelAndAction = [];
                labelAndAction.push(
                    {
                        label: '모든 태그', action: () => {
                            this.cur_tag_sort_key = '멤버톡 태그';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '매치 뛰기', action: () => {
                            this.cur_tag_sort_key = '매치 뛰기';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '용병 모집', action: () => {
                            this.cur_tag_sort_key = '용병 모집';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '조기축구', action: () => {
                            this.cur_tag_sort_key = '조기축구';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '친목', action: () => {
                            this.cur_tag_sort_key = '친목';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '국내축구', action: () => {
                            this.cur_tag_sort_key = '국내축구';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '해외축구', action: () => {
                            this.cur_tag_sort_key = '해외축구';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '팬클럽', action: () => {
                            this.cur_tag_sort_key = '팬클럽';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '경기 직관', action: () => {
                            this.cur_tag_sort_key = '경기 직관';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '레슨', action: () => {
                            this.cur_tag_sort_key = '레슨';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '훈련', action: () => {
                            this.cur_tag_sort_key = '훈련';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '유소년', action: () => {
                            this.cur_tag_sort_key = '유소년';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '여자축구', action: () => {
                            this.cur_tag_sort_key = '여자축구';
                            this.page = 1;
                            this.chatList = [];
                            this.getMadeByMeChatList();
                            this.isShowPopMenu = false
                        },
                    },
                );

                this.menuOptions = {
                    labelAndAction: labelAndAction,
                    isExistCancelBtn: true,
                    closeAction: () => {
                        this.isShowPopMenu = false
                    }
                }

                this.isShowPopMenu = true
            },
            async getMadeByMeChatList() {
                this.isEnableNextPageHandleRecruit = false;

                const parameters = {}
                parameters.page = this.pageRecruit;
                parameters.state = JOIN_STATE.OPEN;
                parameters.is_with_members = true;
                parameters.is_with_chat = true;
                if (this.isExpert) {
                    parameters.my_type = 'all';
                } else {
                    parameters.is_without_coach_made = true;
                }

                if(this.cur_age_sort_key !== '모든 나이대') parameters.age = this.cur_age_sort_key;
                if(this.cur_tag_sort_key !== '멤버톡 태그') parameters.join_tag = this.cur_tag_sort_key;

                const res = await this.$Axios.get('/api/join/list', { params: parameters });
                const joinList = res.data.joins;

                if (joinList.length > 0) {
                    this.isEnableNextPageHandleRecruit = true;
                    this.chatList = [...this.chatList, ...joinList]
                }
            },
        },
        mounted(){
            setTimeout(() => {
                this.isOpen = true;
            }, 100)
        },
        created(){
            this.getMadeByMeChatList();
            //this.$GlobalStore.addModal('TestModal', {transitionName : '', isModalBackTransparent : true});
        }
    }
</script>

<style scoped>

</style>